import { ApiRequestModel } from "../api_request_model";
import { BaseClass } from "../master/mastermodel";

export class FDDocRequest extends BaseClass {
  //public ConditionalOperator: number;
  public TemplateCode: number;
  public TemplateName: string;
  public ShortName: string;
  public Description: string;
  public HeaderLine1: string;
  public HeaderLine2: string;
  public Title: string;
  public Caption: string;
  public FooterLine1: string;
  public FooterLine2: string;
  public RecordStatus: string;
  public CreatedUserName: string;
  public IsActive: boolean;
  public logoCode: number;
  public FDReportType: string;
  public FDResultType: string;
  public FDSpecialty: string;
  //public SendApiRequestModel: ApiRequestModel;
}



export class FdDocTemplateController {
  public TemplateCode: number;
  public TemplateName: string;
  public ShortName: string;
  public Description: string;
  public Title: string;
  public Caption: string;
  public HeaderLine1: string;
  public HeaderLine2: string;
  public FooterLine1: string;
  public FooterLine2: string;
  public RecordStatus: string;
  public IsActive: boolean;
  public CreatedUserName: string;
  public TemplateBodyCode: number;
  public ReportType: string;
  public ResultType: string;
  public Specialty: string;
}


export class FDSectionRequest extends BaseClass {
 // public ConditionalOperator: number;
  public SectionCode: number;
  public BodyCode: number;
  public SectionTitle: string;
  public SectionTitleByLine: string;
  public ShowTitle: boolean;
  public SectionType: string;
  public SequenceNo: number;
  public RecordStatus: string;
  public CreatedUserName: string;
  public IsActive: boolean;
 // public SendApiRequestModel: ApiRequestModel;
}


export class FdSectionsController{
  public SectionCode: number;
  public BodyCode: number;
  public SectionTitle: string;
  public SectionTitleByLine: string;
  public ShowTitle: boolean;
  public SectionType: string;
  public SequenceNo: number;
  public RecordStatus: string;
  public CreatedUserName: string;
  public IsActive: boolean;
}

export class FDSectionFieldRequest extends BaseClass {
 // public ConditionalOperator: number;
  public SectionTypeCode: number;
  public SectionCode: number;
  public SectionType: string;
  public FieldTitle: string;
  public ValueType: string;
  public ValueSource: string;
  public SequenceNo: number;
  public MaxChars: number;
  public CanShowRemarks: boolean;
  public Remarks: string;
  public ValidationExpr: string;
  public RecordStatus: string;
  public CreatedUserName: string;
  public IsActive: boolean;
  public CanShowTitle: boolean;
 // public SendApiRequestModel: ApiRequestModel;
}
export class FdSectionDetailsController {
  public SectionTypeCode: number;
  public BodyCode: number;
  public SectionTitle: string;
  public SectionTitleByLine: string;
  public ShowTitle: boolean;
  public SectionType: string;
  public SectionCode: number;
  public FieldTitle: string;
  public ValueType: string;
  public ValueSource: string;
  public ValidationExpr: string;
  public MaxChars: number;
  public SequenceNo: number;
  public CanShowRemarks: boolean;
  public Remarks: string;
  public RecordStatus: string;
  public IsActive: boolean;
  public CanShowTitle: boolean;
}
export class FDActorDocRequest extends BaseClass {
 // public ConditionalOperator: number;
  public ActorReportTemplateCode: number;
  public ActorReportCode: number;
  public ActorCode: number;
  public CreatedUserName: string;
 // public SendApiRequestModel: ApiRequestModel;

}
export class FdActorReportsDocController {
  public ActorReportCode: number;
  public ReportType: string;
  public ActorCode: number;
  public ActorReportTemplateCode: number;
  public Date: Date;
  public TemplateCode: number;
  public TemplateName: string;
  public TemplateShortName: string;
  public TemplateDescription: string;
  public TemplateBodyCode: number;
  public ResultType: string;
  public TotalTemplateScore: number;
  public ResultScoreCard: number;
  public ScorePercent: number;
  public Specialty: string;

}

export class FdActorDocReportDetailsController{
  public ActorCode: number;
  public SectionTitle: string;
  public SectionSequenceNO: number;
  public SectionTypeCode: number;
  public SectionCode: number;
  public AttributeName: string;
  public ValueData: string;
  public ValueType: string;
  public SequenceNo: number;
  public HasUnit: boolean;
  public Unit: string;
  public ValueSource: string;
  public HasChildAttributes: boolean;
  public RootCOde: number;
  public ParentCode: number;
  public UOM: string;
  public Unitsdata: string;
  public Remarks: string;
  public Fileid: string;
  public FileExtension: number;
  public ActorReportType: number;
  public CanShowTitle: boolean;
  public SectionType: number;
  public ActorReportTypeCode: number;
  public ResultType: string;
}
export class FDActorReportDetailsDocRequest extends BaseClass {
  //public ConditionalOperator: number;
  public FdActorDocReportDetailsController: FdActorDocReportDetailsController[];
  //public SendApiRequestModel: ApiRequestModel;
}

export class FdActorDocReportDetailsBySectionCode extends BaseClass {
  public ActorReportTemplateCode: number;
  public ActorReportCode: number;
  public ActorCode: number;
  public SectionCode: number;

}
